'use strict';

import { BaseController } from '../../../../base/controller';

export class ContractPartnerCancellationController extends BaseController {
  constructor(
    $rootScope,
    $scope,
    controllerService,
    cardService,
    uiModalDeclarationService,
    creditorsService,
    ticketService,
  ) {
    'ngInject';
    super({
      $rootScope,
      $scope,
      controllerService,
      cardService,
      uiModalDeclarationService,
      creditorsService,
      ticketService,
    });
  }

  $onInit() {
    this.card = this.resolve.card;
    this.model = angular.copy(this.card.cancelContractPartner) || {};
  }

  cancel() {
    this.dismiss({ $value: this.card });
  }

  assignModelToCard() {
    const { date, contractId, comment } = this.model;
    this.card.cancelContractPartner = {
      cancel: true,
      date: date ? date.replace('T00:00:00.000Z', '') : null,
      contractId,
      comment,
    };
  }

  confirm() {
    this.assignModelToCard();
    this.close({ $value: this.card });
  }
}
